/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React from "react";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import LayersIcon from '@mui/icons-material/Layers';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import "./style.css";

export const ProgressBar = (props) => {
    const { page } = props;

    function loadrightorange(whichpage) {
        switch (whichpage) {
            case "upload": {
                return (
                    <div className="stages">
                        <div className="left-button">
                            <button className="orange-text">Upload File</button>
                            <UploadFileIcon className="current-icon" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Checklist</div>
                            <ContentPasteIcon className="grey-icon" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Pallets Required</div>
                            <LayersIcon className="grey-icon" icon="layers-filled" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Placement</div>
                            <ViewModuleIcon className="grey-icon" />
                        </div>
                        <div className="right-button">
                            <div className="grey-text">3D Packing</div>
                            <SpaceDashboardIcon className="grey-icon" />
                        </div>
                    </div>
                )
            }
            case "checklist":{
                return (
                    <div className="stages">
                        <div className="done-left-button">
                            <button className="done-text">Upload File</button>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="current-button-mid">
                            <div className="orange-text">Checklist</div>
                            <ContentPasteIcon className="current-icon" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Pallets Required</div>
                            <LayersIcon className="grey-icon" icon="layers-filled" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Placement</div>
                            <ViewModuleIcon className="grey-icon" />
                        </div>
                        <div className="right-button">
                            <div className="grey-text">3D Packing</div>
                            <SpaceDashboardIcon className="grey-icon" />
                        </div>
                    </div>
                )
            }
            case "pallets":{
                return (
                    <div className="stages">
                        <div className="done-left-button">
                            <button className="done-text">Upload File</button>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Checklist</div>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="current-button-mid">
                            <div className="orange-text">Pallets Required</div>
                            <LayersIcon className="current-icon" icon="layers-filled" />
                        </div>
                        <div className="grey-button">
                            <div className="grey-text">Placement</div>
                            <ViewModuleIcon className="grey-icon" />
                        </div>
                        <div className="right-button">
                            <div className="grey-text">3D Packing</div>
                            <SpaceDashboardIcon className="grey-icon" />
                        </div>
                    </div>
                )
            }
            case "placement":{
                return (
                    <div className="stages">
                        <div className="done-left-button">
                            <button className="done-text">Upload File</button>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Checklist</div>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Pallets Required</div>
                            <CheckCircleIcon className="done-icon" icon="layers-filled" />
                        </div>
                        <div className="current-button-mid">
                            <div className="orange-text">Placement</div>
                            <ViewModuleIcon className="current-icon" />
                        </div>
                        <div className="right-button">
                            <div className="grey-text">3D Packing</div>
                            <SpaceDashboardIcon className="grey-icon" />
                        </div>
                    </div>
                )
            }
            case "packing":{
                return (
                    <div className="stages">
                        <div className="done-left-button">
                            <button className="done-text">Upload File</button>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Checklist</div>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Pallets Required</div>
                            <CheckCircleIcon className="done-icon" icon="layers-filled" />
                        </div>
                        <div className="done-button">
                            <div className="done-text">Placement</div>
                            <CheckCircleIcon className="done-icon" />
                        </div>
                        <div className="current-right-button">
                            <div className="orange-text">3D Packing</div>
                            <SpaceDashboardIcon className="current-icon" />
                        </div>
                    </div>
                )
            }

        }
    }

    return (
        <div className="breadcrumb">
            {loadrightorange(page)}
        </div>
    )
}

export default ProgressBar;